<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav="matSidenav" class="sidenav mat-elevation-z8">
        <button mat-button class="menu-button" routerLink="/">
            <i class="fas fa-home"></i>
            <span>Home</span>
        </button>
        <!-- <button mat-button class="menu-button" (click)="toggle()">
            <i class="fas fa-upload"></i>
            <span>Upload Data</span>
        </button>
        <div *ngIf="this.uploadToggle">
            <button mat-button class="menu-upload" routerLink="/data-upload/sensor">
                <i class="fas fa-satellite-dish"></i>
                <span>Sensor Data</span>
            </button>
            <button mat-button class="menu-upload" routerLink="/data-upload/biological">
                <i class="fas fa-dna"></i>
                <span>Biological Data</span>
            </button>
            <button mat-button class="menu-upload" routerLink="/data-upload/physicochemical">
                <i class="fas fa-vial"></i>
                <span>Physicochemical Data</span>
            </button>
            <button mat-button class="menu-upload" routerLink="/data-upload/literature">
                <i class="fas fa-file"></i>
                <span>Literature Data</span>
            </button>
        </div> -->
        <button mat-button class="menu-button" routerLink="/search">
            <i class="fas fa-search"></i>
            <span>Search Data</span>
        </button>
        <button mat-button class="menu-button" routerLink="/early-warnings">
            <i class="fas fa-chart-bar"></i>
            <span>Early Warnings</span>
        </button>
        <button mat-button class="menu-button">
            <i class="fas fa-qrcode"></i>
            <span>Track Product</span>
        </button>
        <button mat-button class="menu-button">
            <i class="fas fa-info-circle"></i>
            <span>About</span>
        </button>
    </mat-sidenav>
    <mat-sidenav-content>
            <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>